import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let TreeDialog = class TreeDialog extends Vue {
    closeDialog() {
        this.$emit("close-dialog");
    }
    confirm() {
        this.$emit("confirm");
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: "编辑信息" })
], TreeDialog.prototype, "dialogTitle", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], TreeDialog.prototype, "clientX", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], TreeDialog.prototype, "clientY", void 0);
TreeDialog = tslib_1.__decorate([
    Component({
        name: 'TreeDialog',
    })
], TreeDialog);
export default TreeDialog;
